'use client';

import { c as _c } from "react/compiler-runtime";
import { PARAMS_KEY_SUBPRODUCT } from '@/constants/route-params-keys';
import { parseReportSubproduct, resolveReportSubproductForProject, type ReportSubproduct } from '@/domains/reports/utils/report-subproduct.utils';
import { useProjectsContext } from '@/providers/projects-provider';
import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';
export function useReportSubproductParam() {
  const $ = _c(3);
  const searchParams = useSearchParams();
  const {
    selectedProject
  } = useProjectsContext();
  selectedProject?.product;
  let t0;
  if ($[0] !== searchParams || $[1] !== selectedProject?.product) {
    const parsed = parseReportSubproduct(searchParams?.get(PARAMS_KEY_SUBPRODUCT));
    t0 = resolveReportSubproductForProject(parsed, selectedProject?.product);
    $[0] = searchParams;
    $[1] = selectedProject?.product;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
export function useReportSubproductQueryValue() {
  const $ = _c(2);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = parseReportSubproduct(searchParams?.get(PARAMS_KEY_SUBPRODUCT));
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}